import styled, { css } from 'styled-components';
import { ButtonGroupDirection } from './ButtonGroup.types';
export const Container = styled.div `
    display: flex;
    gap: 10px;
    ${props => {
    switch (props.$direction) {
        case ButtonGroupDirection.ROW:
            return css `
                    flex-direction: row;
                `;
        default:
        case ButtonGroupDirection.COLUMN:
            return css `
                    flex-direction: column;
                `;
    }
}}
`;
